"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect } from "react";
import PortalClient from "@/components/portal/Portal";
import { X } from "lucide-react";
interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}
const BottomSheet = t0 => {
  const $ = _c(18);
  const {
    open,
    onClose,
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] !== open) {
    t1 = () => {
      if (open) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
      return _temp;
    };
    t2 = [open];
    $[0] = open;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!open) {
    return null;
  }
  let t3;
  if ($[3] !== onClose) {
    t3 = <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm transition-opacity duration-300 opacity-100" onClick={onClose} />;
    $[3] = onClose;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center justify-center pt-3 pb-2"><div className="w-12 h-1.5 bg-muted-foreground/30 rounded-full" /></div>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <h2 className="text-xl font-semibold text-foreground">فیلتر</h2>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <X className="h-5 w-5 text-foreground" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== onClose) {
    t7 = <div className="flex items-center justify-between px-6 pb-4 border-b border-border">{t5}<button aria-label={"\u0628\u0633\u062A\u0646"} data-role="close" onClick={onClose} className="rounded-full p-2 hover:bg-muted cursor-pointer transition-colors">{t6}</button></div>;
    $[8] = onClose;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== children) {
    t8 = <div className="flex-1 overflow-y-auto px-6 py-6">{children}</div>;
    $[10] = children;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className="fixed inset-0 z-50 flex items-end justify-center pointer-events-none"><div className="w-full max-w-full h-[90vh] bg-background rounded-t-3xl shadow-2xl pointer-events-auto overflow-hidden flex flex-col animate-in slide-in-from-bottom duration-300" onClick={_temp2} data-test-id="bottom-sheet-content">{t4}{t7}{t8}</div></div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t9) {
    t10 = <PortalClient>{t3}{t9}</PortalClient>;
    $[15] = t3;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
};
export default BottomSheet;
function _temp() {
  document.body.style.overflow = "";
}
function _temp2(e) {
  return e.stopPropagation();
}